<template>
  <div class="time-series" style="width: 100%">
    <fade-transition>
      <div class="about-modal" v-if="modalVisible">
        <div class="modal-body">
          <button class="modal-close-btn" @click.prevent="closeModal">
            {{ $t("cross") }}
          </button>

          <concordance-request
            :concordance-word="concordance_word"
            :execute-on-mount="true"
            :publication-year="concordance_year"
          ></concordance-request>
        </div>
      </div>
    </fade-transition>
    <div class="view-content">
      <div class="component-container" id="mygrid">
        <TaskFilter
          :output="setFilters"
          v-show="show.filters"
          :visible="hideFilters"
        ></TaskFilter>
        <div
          id="area1"
          v-bind:class="{
            'box-container-form': task.finished,
            'box-container': !task.finished,
          }"
        >
          <div class="content-container">
            <!-- title header -->
            <div class="container-header">
              <p class="method-title">SZEREGI CZASOWE</p>
              <router-link v-if="task.finished" :to="{ name: 'TimeSeries' }">
                <button
                  class="box-close-btn"
                  @click.prevent="task.finished = false"
                >
                  {{ $t("cross") }}
                </button>
              </router-link>
              <router-link v-if="!task.finished" :to="{ name: 'Home' }">
                <button class="box-close-btn">{{ $t("cross") }}</button>
              </router-link>
            </div>

            <b-form @submit="startTask">
              <b-form-group
                :label="this.$t('time_series.word')"
                v-if="semantic_list.selected === -1"
                label-for="timeSeriesOrth"
                title="przy wprowadzaniu wielu wyrazów, konieczna walidacja enterem. "
              >
                <input-tag
                  v-if="semantic_list.selected === -1"
                  :add-tag-on-blur="true"
                  v-model="orth"
                  :limit="5"
                  :add-tag-on-keys="[13, 188, 9, 32]"
                ></input-tag>
              </b-form-group>

              <b-form-group :label="this.$t('time_series.part_of_speech')">
                <b-form-select
                  selected=""
                  required
                  v-model="part_of_speech.selected"
                  :options="part_of_speech.options"
                />
              </b-form-group>

              <b-form-group :label="this.$t('time_series.time_unit')">
                <b-form-select
                  selected=""
                  required
                  v-model="time_unit.selected"
                  :options="time_unit.options"
                />
              </b-form-group>

              <b-form-group :label="this.$t('time_series.semantic_list')">
                <b-form-select
                  selected=""
                  v-model="semantic_list.selected"
                  :options="semantic_list.options"
                  @change="submitDisabled"
                />
              </b-form-group>
              <!-- Action btn -->
              <b-form-group class="filters">
                <input-tag
                  v-show="metadata_filters.length > 0"
                  v-model="filters_tagset"
                  :delete-on-backspace="true"
                  :read-only="false"
                ></input-tag>
                <b-button
                  :disabled="submit_disabled"
                  class="btn-block submit-button button-80"
                  type="submit"
                  v-if="!show.loading"
                >
                  {{ $t("quantity_analysis.submit") }}
                </b-button>
                <b-button
                  class="btn-block submit-button button-80"
                  disabled
                  v-if="show.loading"
                >
                  <b-spinner small type="grow" />
                  <span v-if="task.finished">{{ $t("task.loading_data") }}</span
                  ><span v-if="!task.finished">{{
                    $t("task.waiting_for_response")
                  }}</span>
                </b-button>
                <b-button
                  class="filter-button button-20"
                  @click="showFilters"
                  v-show="!show.filters"
                >
                  <i class="fas fa-filter"></i>
                </b-button>
                <b-button
                  class="filter-button button-20"
                  @click="hideFilters"
                  v-show="show.filters"
                >
                  <i class="fas fa-filter"></i>
                </b-button>
              </b-form-group>

              <p></p>

              <span style="visibility: hidden">spacer</span>
            </b-form>
          </div>
        </div>
        <div
          class="text-center box-container-result"
          v-if="task.finished"
          id="area2"
        >
          <div class="content-container" ref="chartContainer">
            <div v-if="show.chart">
              <b-button
                v-if="chart.length > 2"
                v-for="item in this.chart"
                @click.prevent="changeChart(item.button.index)"
                :key="item.button.index"
                type="button"
                size="sm"
                :class="
                  'btn filter-button btn-secondary' +
                  (instance && !instance[item.button.index].hidden
                    ? ' active' + '-' + item.button.index
                    : '')
                "
                style="margin: 3px; float: left"
              >
                {{ item.button.label }}
              </b-button>
              <b-button
                class="btn filter-button"
                size="sm"
                @click="log = !log"
                style="margin: 3px; float: left"
                :title="$t('scale.title')"
              >
                {{ $t("scale." + log.toString()) }}
              </b-button>
              <b-button
                v-on:click="export2image"
                type="button"
                size="sm"
                class="btn submit-button btn-secondary"
                style="margin: 3px; float: right"
              >
                {{ $t("download") }} PNG
              </b-button>

              <b-dropdown
                id="dropdown-buttons"
                text="Pobierz TSV"
                size="sm"
                class="btn-tsv filter-button btn-secondary"
              >
                <b-dropdown-item-button
                  v-for="(file, file_name) in this.file_data"
                  :key="file.id"
                >
                  <vue-json-to-csv
                    :json-data="file"
                    :csv-title="file_name"
                    :separator="'\t'"
                  >
                    {{ file_name }}
                  </vue-json-to-csv>
                </b-dropdown-item-button>
              </b-dropdown>
              <b-button
                v-on:click="redrawChart()"
                type="button"
                size="sm"
                class="btn filter-button btn-secondary"
                style="margin: 3px; float: right"
              >
                ⟲
              </b-button>
            </div>
            <b-spinner v-if="show.loading" style="width: 3rem; height: 3rem" />
            <fade-transition>
              <line-chart
                :height="chartHeight"
                :width="chartWidth"
                :chart-data="final_chart"
                :options="options"
                v-if="show.chart"
                @on-receive="getConcordance"
              ></line-chart>
            </fade-transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FadeTransition from "@/components/FadeTransition.vue";
import axios from "axios";
import TaskFilter from "@/components/TaskFilter";
import LineChart from "@/components/LineChart";
import VueJsonToCsv from "vue-json-to-csv";
import InputTag from "vue-input-tag";
import ConcordanceRequest from "@/components/ConcordanceRequest";
import ErrorPopup from "../components/ErrorPopup.vue";

const ts_colors = [
  "#d62728",
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#17becf",
];
export default {
  name: "TimeSeries",
  components: {
    LineChart,
    TaskFilter,
    axios,
    FadeTransition,
    VueJsonToCsv,
    InputTag,
    ConcordanceRequest,
    ErrorPopup,
  },
  data() {
    return {
      chart_title: "",
      modalVisible: false,
      chart_i: 0,
      json_data: [],
      orth: [],
      concordance_word: "",
      concordance_year: "",
      task: {
        id: null,
        status: "",
        result: "",
        finished: false,
        unit: "year",
      },
      show: {
        loading: false,
        filters: false,
        chart: false,
      },
      time_series: [],
      metadata_filters: [],
      log: false,
      instance: [
        { hidden: false },
        { hidden: false },
        { hidden: false },
        { hidden: false },
        { hidden: false },
        { hidden: false },
      ],
      chart: [],
      final_chart: [],
      ch_buttons: [],
      pointData: {},
      chartHeight: 470,
      chartWidth: 1470,
      chart_init: false,
      file_data: {},
      words: [],
      mav: false,
      submit_disabled: true,
    };
  },
  computed: {
    filters_tagset: {
      get: function f() {
        let tag_array = [];
        this.metadata_filters.forEach((x) => {
          tag_array = tag_array.concat(x.value.split(";"));
        });
        return tag_array;
      },
      set: function f1() {
        this.metadata_filters.forEach((x) => {
          this.$emit("myEvent");
        });
      },
    },
    part_of_speech() {
      return {
        selected: "2",
        options: [
          { value: "0", text: this.$t("all") },
          { value: "1", text: this.$t("verb") },
          { value: "2", text: this.$t("noun") },
          { value: "3", text: this.$t("adverb") },
          { value: "4", text: this.$t("adjective") },
        ],
      };
    },
    time_unit() {
      return {
        selected: "month",
        options: [
          { value: "month", text: this.$t("month") },
          { value: "year", text: this.$t("year") },
        ],
      };
    },
    semantic_list() {
      return {
        selected: -1,
        options: [
          { value: -1, text: this.$t("semantic_list.deselect") },
          { value: "colors", text: this.$t("semantic_list.colors") },
        ],
      };
    },
    options() {
      let word = this.words;
      var self = this;
      return {
        title: {
          display: true,
          text:
            this.$t("time_series.chart_title") + ' "' + this.chart_title + '"',
          fontStyle: { family: "Jost" },
        },
        scales: {
          yAxes: [
            {
              type: this.log ? "logarithmic" : "linear",
              scaleLabel: {
                display: true,
                labelString: this.$t("time_series.frequency"),
              },
              ticks: {
                display: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.$t(
                  "time_series.time_unit" + this.time_unit.selected.toString()
                ),
              },
              ticks: {
                beginAtZero: true,
                display: true,
              },
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: true,
          mode: "single",
          callbacks: {
            label: function (tooltipItems, data) {
              self.concordance_word = word[tooltipItems.datasetIndex];
              return tooltipItems.yLabel + " " + self.concordance_word;
            },
          },
        },
        responsive: false,
        maintainAspectRatio: true,
        bezierCurve: false,
      };
    },
  },
  watch: {
    options: function () {
      this.redrawChart();
    },
    orth: function () {
      this.submitDisabled();
    },
  },
  methods: {
    submitDisabled() {
      this.submit_disabled =
        this.orth.length < 1 && this.semantic_list.selected === -1;
    },
    showFilters: function () {
      this.show.filters = true;
    },
    hideFilters: function () {
      this.show.filters = false;
    },
    setFilters: function (metadata, all) {
      this.metadata_filters = [];
      for (let i = 0; i < all.length; i++) {
        if (
          typeof metadata[all[i]] !== "undefined" &&
          metadata[all[i]] !== ""
        ) {
          this.metadata_filters.push({
            name: all[i],
            value: metadata[all[i]],
          });
        }
      }
      if (
        typeof metadata["publication_year"] !== "undefined" &&
        metadata["publication_year"] !== ""
      ) {
        this.metadata_filters.push({
          name: "publication_year",
          value: metadata["publication_year"],
        });
      }
    },
    startTask: async function (event) {
      event.preventDefault();
      this.words = [];
      this.concordance_word = this.orth[0];
      this.task.finished = false;
      this.show.loading = true;
      this.show.chart = false;
      this.json_data = [];
      this.time_series = {};
      this.chart = [];
      this.chart_init = false;
      this.instance.forEach((x) => (x.hidden = false));
      try {
        let query_parameters = [
          {
            name: "part_of_speech",
            value: this.part_of_speech.selected,
          },
          {
            name: "time_unit",
            value: this.time_unit.selected,
          },
        ];
        if (this.semantic_list.selected !== -1) {
          query_parameters.push({
            name: "semantic_list",
            value: this.semantic_list.selected,
          });
        } else {
          query_parameters.push({
            name: "base",
            value: this.orth.join(";"),
          });
        }

        let response = await axios.post(
          process.env.ROOT_API + "startTask",
          {
            task_type: "time_series",
            metadata_filter: this.metadata_filters,
            query_parameters: query_parameters,
            response_parameters: [],
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
            timeout: 20000,
          }
        );
        this.task.id = response.data.id;
        await this.checkStatus(this.task.id, 200);
      } catch (e) {
        this.$alert("", "Starting a task failed", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    checkStatus: async function (taskId, timer) {
      try {
        timer += 100;
        let response = await axios.get(
          process.env.ROOT_API + "getStatus/" + taskId,
          {
            timeout: 1000,
          }
        );
        this.task.status = response.data.status;
        if (this.task.status === "DONE") {
          this.getResult(taskId);
        } else if (this.task.status === "QUEUE") {
          setTimeout(() => {
            this.checkStatus(taskId, timer);
          }, timer);
        } else if (this.task.status === "ERROR") {
          this.task.finished = true;
          this.task.loading = false;
        }
      } catch (e) {
        this.$alert("", "Error while getting status", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    getResult: async function (taskId) {
      try {
        this.task.finished = true;
        let response = await axios.get(
          process.env.ROOT_API + "getResult/" + taskId,
          {
            timeout: 5000,
          }
        );

        response.data.result.rows.forEach((item, index) => {
          let rowJson = JSON.stringify(item);
          let row = JSON.parse(rowJson);
          this.mapChartData(row.series, row.word, index);
          this.words.push(row.word === "all" ? "Σ" : row.word);
        });

        let all_charts = JSON.parse(JSON.stringify(this.chart[0]));
        all_charts.button.index = this.chart.length;
        all_charts.button.label = "☷";
        all_charts.datasets = [];
        this.chart.forEach((x) => {
          if (!(x.button.label === "Σ" && this.chart.length === 2))
            all_charts.datasets.push(x.datasets[0]);
        });

        this.final_chart = all_charts;

        this.chart_title = this.chart[0].button.label;
        this.resizeChart();

        this.show.loading = false;
      } catch (e) {
        this.$alert("", "Error while getting results", "warning");
        console.log(Object.keys(e), e.message);
        this.show.loading = false;
      }
    },
    mapChartData: function (chartData, word, index) {
      if (word === "all") {
        word = "Σ";
      } else {
        this.file_data[word] = [];
      }
      this.chart[index] = {
        button: {
          label: word,
          index: index,
        },
        labels: [],
        datasets: [
          {
            word: word,
            borderColor: ts_colors[index],
            backgroundColor: "rgba(216,137,35,0)",
            pointBackgroundColor: "rgba(216,137,35,0)",
            pointBorderColor: "rgba(216,137,35,0)",
            borderWidth: 0,
            data: [],
            radius: 5,
            lineTension: 0.4,
          },
        ],
      };
      try {
        let years = this.getYears(chartData);
        for (let y = years[0]; y <= years[1]; y++) {
          if (this.time_unit.selected === "year") {
            this.time_series[y] = { value: 0, label: y };
          } else if (this.time_unit.selected === "month") {
            this.time_series[y] = {
              1: { value: 0, label: "1-" + y },
              2: { value: 0, label: "2-" + y },
              3: { value: 0, label: "3-" + y },
              4: { value: 0, label: "4-" + y },
              5: { value: 0, label: "5-" + y },
              6: { value: 0, label: "6-" + y },
              7: { value: 0, label: "7-" + y },
              8: { value: 0, label: "8-" + y },
              9: { value: 0, label: "9-" + y },
              10: { value: 0, label: "10-" + y },
              11: { value: 0, label: "11-" + y },
              12: { value: 0, label: "12-" + y },
            };
          }
        }
        for (let i = 0; i <= chartData.length; i++) {
          for (var key in chartData[i]) {
            if (this.time_unit.selected === "year") {
              this.time_series[key].value = chartData[i][key];
            } else if (this.time_unit.selected === "month") {
              let date = key;
              let splittedDate = date.split("-");
              this.time_series[splittedDate[1]][splittedDate[0]].value =
                chartData[i][key];
            }
          }
        }

        for (var x in this.time_series) {
          if (this.time_unit.selected === "year") {
            this.chart[index].datasets[0].data.push(this.time_series[x].value);
            this.chart[index].labels.push(this.time_series[x].label);

            if (word != "Σ") {
              this.file_data[word].push({
                year: x,
                frequency: this.time_series[x].value,
              });
            }
          } else if (this.time_unit.selected === "month") {
            for (let i = 1; i <= 12; i++) {
              this.chart[index].datasets[0].data.push(
                this.time_series[x][i].value
              );
              this.chart[index].labels.push(this.time_series[x][i].label);
              this.json_data.push({
                year: x,
                month: i,
                frequency: this.time_series[x][i].value,
              });
              if (word != "Σ") {
                this.file_data[word].push({
                  year: x,
                  month: i,
                  frequency: this.time_series[x][i].value,
                });
              }
            }
          }
        }
        if (this.mav) this.movingAverage(index);

        this.show.chart = true;
      } catch (e) {
        this.$alert("", "Error while getting map data", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    getYears: function (data) {
      try {
        let years = [];
        for (let i = 0; i <= data.length; i++) {
          for (var key in data[i]) {
            if (this.time_unit.selected === "year") {
              years.push(parseInt(key));
            } else if (this.time_unit.selected === "month") {
              let fullDate = key;
              let splittedDate = fullDate.split("-");
              years.push(parseInt(splittedDate[1]));
            }
          }
        }
        return [Math.min.apply(null, years), Math.max.apply(null, years)];
      } catch (e) {
        this.$alert("", "Error while getting data", "warning");

        console.log(Object.keys(e), e.message);
      }
    },
    export2image: function (event) {
      event.preventDefault();
      let canvas = document.getElementById("line-chart").toDataURL("image/png");
      let link = document.createElement("a");
      link.download = "time_series_chart";
      link.href = canvas;

      var mouseEvent = new MouseEvent("click");
      link.dispatchEvent(mouseEvent);
    },

    getConcordance: function (data) {
      this.concordance_year = data.year;

      if (this.concordance_word !== "Σ") {
        this.modalVisible = true;
      }
    },
    resizeChart: function () {
      if (this.task.finished) {
        if (window.innerWidth > 768) {
          this.chartHeight = Math.ceil(
            this.$refs.chartContainer.clientHeight * 0.8
          );
          this.chartWidth = Math.ceil(
            this.$refs.chartContainer.clientWidth * 0.98
          );
        } else {
          this.chartHeight = Math.ceil(470);
          this.chartWidth = Math.ceil(1000);
        }
      }
    },
    redrawChart: function () {
      this.show.chart = false;
      this.resizeChart();
      setTimeout(() => {
        this.show.chart = true;
      }, 0.1);
    },
    handleResize(event) {
      if (this.task.finished) {
        this.redrawChart();
      }
    },
    changeChart: function (index) {
      if (!this.chart_init) {
        let ch = Chart.instances;
        this.instance = ch[Object.keys(ch)[0]].data.datasets;
      }

      this.instance[index].hidden = !this.instance[index].hidden;

      this.redrawChart();
    },
    toggleModal() {
      this.modalVisible = !this.modalVisible;
    },
    closeModal() {
      this.modalVisible = false;
    },
    movingAverage: function (i) {
      function simpleMovingAverage(arr, window = 7, n = Infinity) {
        if (!arr || arr.length < window) {
          return [];
        }

        let index = window - 1;
        const length = arr.length + 1;

        const simpleMovingAverages = [];

        let numberOfSMAsCalculated = 0;

        while (++index < length && numberOfSMAsCalculated++ < n) {
          const windowSlice = arr.slice(index - window, index);
          const sum = windowSlice.reduce((prev, curr) => prev + curr, 0);
          simpleMovingAverages.push(sum / window);
        }

        return simpleMovingAverages;
      }
      let tmpData = JSON.parse(JSON.stringify(this.chart[i].datasets[0].data));
      if (typeof this.chart[i] !== "undefined") {
        this.chart[i].datasets[0].data = simpleMovingAverage(tmpData);
      }
    },
  },
  created: function () {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>
.component-container {
  background-color: transparent;
  height: 85vh;
}
.box-container {
  border-radius: 0;
}
.container-header {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.container-header {
  display: flex;
  align-items: flex-start;
  background-color: var(--white_grey);
  align-items: center;
  border-radius: 5px;
  margin-bottom: 8px;
  padding-right: 4px;
}
.method-title {
  display: flex;
  width: 100%;
  font-weight: bold;
  color: var(--grey_black);
  margin: 6px;
  justify-content: center;
}
.btn-tsv {
  float: right;
  margin: 3px;
  border: none;
  border-radius: 0.2rem !important;
}

.box-close-btn {
  width: 25px;
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  border: none;
}
.time-series {
  background-color: var(--grey_alpha);
}
.box-container-form {
  width: 25%;
}
.box-container-result {
  background-color: var(--white_alpha);
}
.active,
.active:focus {
  background-color: var(--orange) !important;
  color: var(--grey_black) !important;
  font-family: "Jost", sans-serif;
}
.about {
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 70%;
  height: 80%;
  margin-top: 2rem;
  padding-top: 3rem;
  padding-bottom: 3rem;
  margin-bottom: 3rem;
  margin-bottom: 1rem;
  background-color: rgba(255, 255, 255, 0.542);
}
.about-text {
  width: 70%;
  padding-left: 1vw;
  padding-right: 1vw;
  padding-bottom: 1rem;
  background-color: rgb(255, 255, 255);
  overflow-y: auto;
}
.about-text p {
  font-size: 1rem;
}
.about p {
  text-justify: newspaper;
}
.about-modal {
  background-color: var(--grey_alpha_old);
  z-index: 1000;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}
.modal-close-btn {
  z-index: 99;
  position: absolute;
  top: 2rem;
  right: 13%;
  width: 3rem;
  height: 3rem;
  color: rgb(105, 105, 105);
  background-color: white;
  border: none;
  outline: none;
  font-weight: bold;
}
.modal-close-btn:hover {
  font-size: 1.2rem;
}
.vue-input-tag-wrapper .input-tag {
  color: white;
  background-color: #5b5b5b;
  border-color: var(--orange);
  border-radius: 8px;
}
.vue-input-tag-wrapper .input-tag .remove {
  color: var(--orange);
}
@media only screen and (max-width: 768px) {
  #mygrid {
    display: grid;
    grid-template-areas:
      "area1"
      "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
  }
  #area2 {
    grid-area: area2;
    position: relative;
    width: 100%;
    height: 600px;
  }
}
@media only screen and (max-width: 375px) {
  #mygrid {
    display: grid;
    grid-template-areas: "area1" "area2";
  }
  #area1 {
    grid-area: area1;
    position: relative;
    width: 100%;
    height: fit-content;
  }
  #area2 {
    z-index: 99;
    grid-area: area2;
    position: relative;
    width: 100%;
    padding-bottom: 1rem;
  }
  #area2 .content-pagination {
    display: flex;
    flex-direction: column;
    height: fit-content;
  }
  .rows-count {
    margin-bottom: 0.2rem;
  }
  .filter-button {
    float: none !important;
  }
  #area2 .content-list {
    font-size: 12px;
  }
}
.active-0 {
  background-color: #d62728 !important;
}
.active-1 {
  background-color: #1f77b4 !important;
}
.active-2 {
  background-color: #ff7f0e !important;
}
.active-3 {
  background-color: #2ca02c !important;
}
.active-4 {
  background-color: #9467bd !important;
}
.active-5 {
  background-color: #8c564b !important;
}
</style>

<style>
.dropdown-toggle {
  border: none !important;
  background-color: var(--grey_dark1) !important;
  border-radius: 0.2rem !important;
}
</style>



// WEBPACK FOOTER //
// src/views/TimeSeries.vue